import { forwardRef, useImperativeHandle, useState } from 'react'
import { Modal, Input, message, InputNumber } from 'antd'
import { apiObj } from '@/common/common'

const wrapClass = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '20px'
}
const labelClass = {
  width: '50px'
}
const inpClass = {
  width: '100%'
}

const SheetModal = forwardRef((props, ref) => {
  const [flag, setFlag] = useState(false) // 是否显示
  const [type, setType] = useState('add') // 添加或编辑
  const [title, setTitle] = useState('新增歌单') // 标题
  const [curSheet, setCurSheet] = useState(null) // 当前歌单
  const [sheetValue, setSheetValue] = useState('') // 歌单名称
  const [sortValue, setSortValue] = useState(0) // 排序
  const [sheetName, setSheetName] = useState('') // 表名
  const [disabled, setDisabled] = useState(false) // 是否禁用（编辑的时候禁用）
  const [confirmLoading, setConfirmLoading] = useState(false) // 确认按钮loading
  const [messageApi, content] = message.useMessage()
  // 显示添加或编辑歌单弹框
  const show = (val, sheet) => {
    console.log(val, sheet)
    setType(val)
    setFlag(true)
    setDisabled(false)
    setSheetValue('')
    setSheetName('')
    setTitle('新增歌单')
    setCurSheet(null)
    setConfirmLoading(false)
    if (val === 'edit') {
      setCurSheet(sheet)
      setTitle('编辑歌单')
      setSortValue(sheet.sort)
      setDisabled(true)
      setSheetValue(sheet.sheetName)
      setSheetName('编辑时不予展示该字段，嘿嘿嘿！')
    }
  }
  // 确认
  const confirm = () => {
    console.log(sheetValue, sheetName, sortValue)
    if ((!sheetValue || !sortValue) && type === 'edit') {
      messageApi.warning('歌单名称与排序号不能为空')
      return
    } else if ((!sheetValue || !sheetName) && type === 'add') {
      messageApi.warning('歌单名称与表名不能为空')
      return
    }
    setConfirmLoading(true)
    let str = `?name=${sheetValue}&dataBaseName=${sheetName}`
    // 新增歌单
    if (type === 'add') {
      fetch(`${apiObj.url}/sheet/create` + str, {
        method: 'GET'
      })
        .then(res => res.json())
        .then(res => {
          console.log(res)
          if (res.code !== 200) {
            messageApi.error(res.data.msg)
            return
          }
          messageApi.success('创建成功')
          setConfirmLoading(false)
          setFlag(false)
          props.refreshList()
        })
    } else {
      const obj = {
        sheetName: sheetValue,
        sort: sortValue,
        sheetId: curSheet.sheetId
      }
      console.log(obj)
      // 编辑歌单
      console.log('当前歌单', curSheet)
      fetch(`${apiObj.url}/sheet/edit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(obj)
      })
        .then(res => res.json())
        .then(res => {
          console.log('结果', res)
          if (res.code !== 200) {
            messageApi.error(res.data.msg)
            return
          }
          messageApi.success('修改成功')
          setConfirmLoading(false)
          setFlag(false)
          props.refreshList()
        })
    }
  }
  // 导出父组件可调用的方法
  useImperativeHandle(ref, () => ({
    show
  }))
  return (
    <>
      {content}
      <Modal
        class="sheet_modal"
        title={title}
        open={flag}
        onOk={confirm}
        confirmLoading={confirmLoading}
        onCancel={() => setFlag(false)}
      >
        <div style={wrapClass}>
          <span style={labelClass}>歌单：</span>
          <Input
            allowClear
            placeholder="请输入歌单名称"
            value={sheetValue}
            onChange={e => setSheetValue(e.target.value)}
          />
        </div>
        {type === 'edit' && (
          <div style={wrapClass}>
            <span style={labelClass}>排序：</span>
            <InputNumber
              style={inpClass}
              placeholder="请输入排序"
              min={1}
              value={sortValue}
              onChange={e => setSortValue(e)}
            />
          </div>
        )}
        {type === 'add' && (
          <div style={wrapClass}>
            <span style={labelClass}>表名：</span>
            <Input
              disabled={disabled}
              allowClear
              placeholder="请输入表名，格式：歌单拼音，后面的_sheet后台会自己拼接"
              value={sheetName}
              onChange={e => setSheetName(e.target.value)}
            />
          </div>
        )}
      </Modal>
    </>
  )
})

export default SheetModal
